import React from "react";
import { Link } from "react-router-dom";
import {
  FiUsers,
  FiGlobe,
  FiShield,
  FiAward,
  FiArrowRight,
  FiCheckCircle,
} from "react-icons/fi";
import "./About.css";
import profileImg from './profile.jpg';


const About = () => {
  const values = [
    {
      icon: <FiShield />,
      title: "Integrity",
      description:
        "We operate with unwavering ethical standards, ensuring transparency and trust in every engagement.",
    },
    {
      icon: <FiUsers />,
      title: "Discretion",
      description:
        "Strict confidentiality protocols protect our clients' interests and strategic positions.",
    },
    {
      icon: <FiAward />,
      title: "Excellence",
      description:
        "Institutional-grade advisory delivered with precision and deep sector expertise.",
    },
    {
      icon: <FiGlobe />,
      title: "Global Reach",
      description:
        "Cross-border transaction expertise across multiple jurisdictions and markets.",
    },
  ];

  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <h1 className="about-hero-title">Heritage & Vision</h1>
            <p className="about-hero-subtitle">
              Crescent Advisory operates as an independent intermediary and
              strategic advisor across global energy, commodities, real estate,
              and joint venture transactions.
            </p>
          </div>
        </div>
      </section>

      {/* Firm Profile */}
      <section className="firm-profile">
        <div className="container">
          <div className="profile-grid">
            <div className="profile-content fade-in">
              <h2 className="section-title">Who We Are</h2>
              <p className="profile-text">
                Crescent Advisory operates as an independent intermediary and
                strategic advisor across global energy, commodities, real
                estate, and joint venture transactions.
              </p>
              <p className="profile-text">
                We facilitate alignment between principals, investors, and
                counterparties seeking structured opportunities in complex asset
                classes. Our mandate is advisory coordination and counterparty
                qualification, not direct transaction participation unless
                expressly agreed in writing.
              </p>
              <p className="profile-text">
                We maintain strict confidentiality protocols and operate
                exclusively under executed non-disclosure agreements with vetted
                participants.
              </p>
            </div>
            <div className="profile-image slide-in-right">
              <div className="image-wrapper">
                <img src={profileImg} alt="Profile" className="profile-img" />
                <div className="image-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="values-section">
        <div className="container">
          <div className="values-header">
            <h2 className="section-title center">Mission & Values</h2>
            <p className="section-subtitle center">
              Guided by principles that ensure excellence in every engagement
            </p>
          </div>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card scale-in">
                <div className="value-icon">{value.icon}</div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Independent Advisory Framework */}
      <section className="framework-section">
        <div className="container">
          <div className="framework-grid">
            <div className="framework-content fade-in">
              <h2 className="section-title">Independent Advisory Framework</h2>
              <p className="framework-text">
                Crescent Advisory provides independent intermediary services,
                connecting principals with aligned opportunities. Our
                confidential, relationship-driven approach adheres to
                institutional standards for sophisticated clients, without
                proprietary interests.
              </p>
              <ul className="framework-list">
                <li>
                  <FiCheckCircle className="list-icon" />
                  <span>No proprietary positions or conflicts of interest</span>
                </li>
                <li>
                  <FiCheckCircle className="list-icon" />
                  <span>Institutional standards of due diligence</span>
                </li>
                <li>
                  <FiCheckCircle className="list-icon" />
                  <span>Strict confidentiality in all engagements</span>
                </li>
                <li>
                  <FiCheckCircle className="list-icon" />
                  <span>Cross-border transaction expertise</span>
                </li>
              </ul>
            </div>
            <div className="framework-highlight slide-in-right">
              <div className="highlight-card">
                <h3>Global Reach, Selective Mandates</h3>
                <p>
                  With cross-sector expertise and a global network, we
                  facilitate discreet, structurally sophisticated,
                  multi-jurisdictional transactions. We partner selectively with
                  clients prioritizing strategic clarity.
                </p>
                <Link to="/engagement-process" className="btn-outline">
                  Learn About Our Process
                  <FiArrowRight />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Partner with Crescent Advisory</h2>
            <p>
              Explore how our independent advisory can facilitate your strategic
              objectives across global markets.
            </p>
            <Link to="/contact" className="btn-primary">
              Initiate Confidential Discussion
              <FiArrowRight />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
